module.exports = __webpack_public_path__ + "static/media/destacado.6d4f6486.png";